export default __webpack_public_path__ + "static/bg-cycle-1-5310b8fefec480cce88e1bb33a4c22e6.png";